// @flow
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
// Components
import UnconnectedConfirmationPage from '../components/ConfirmationPage';
import UtmSourceAttributionModal from '../components/modals/UtmSourceAttributionModal';
//Connectors
import { userEmailConnector } from '../../user';
// API
import { postVisitorLog, putVisitorLog } from '../../common/api/visitorLogs';
// Logger
import { logAPIException } from '../../logHelper';

type Props = {
  match: any,
  location: any,
  history: any,
};

const ConfirmationPage = (props: Props) => {
  const query = qs.parse(props.location.search.substr(1));
  const orderNumber = props.match.params.id || query.id || '';
  const orderToken =
    props.match.params.order_token || query.order_token || null;

  const attribution = props.location.state || {};

  const [isModalOpen, setIsModalOpen] = useState(
    () => !!attribution.isNewUser && !attribution.hasSource,
  );

  const handleCloseModal = () => {
    setIsModalOpen(false);
    props.history.replace({
      pathname: props.location.pathname,
      search: props.location.search,
      state: undefined,
    });
  };

  const handleSubmitUtmSource = async (utmSource: string) => {
    handleCloseModal();

    const { visitorLogId: snapshotLogId, utmPayload } = attribution;

    const payload = {
      utm_medium: null,
      utm_content: null,
      utm_campaign: null,
      ...(utmPayload || {}),
      utm_source: utmSource,
      order_number: orderNumber,
      order_token: orderToken,
    };

    try {
      let visitorLogId = snapshotLogId;
      if (!visitorLogId) {
        const created = await postVisitorLog({
          utm_source: utmSource,
          utm_medium: null,
          utm_content: null,
          utm_campaign: null,
        });
        visitorLogId = created?.id ? String(created.id) : null;
      }

      if (!visitorLogId) {
        throw new Error('Visitor log id unavailable after creation');
      }

      await putVisitorLog(visitorLogId, payload);
    } catch (e) {
      logAPIException(e, {
        message: 'Failed to save utm source from attribution modal',
        visitorLogId: snapshotLogId,
        orderNumber,
        utmSource,
      });
    }
  };

  return (
    <div>
      <Helmet>
        <title>
          Confirmação do Pedido {orderNumber} - Bigdelivery - Seu açougue
          virtual
        </title>
      </Helmet>
      <UnconnectedConfirmationPage
        orderNumber={orderNumber}
        userEmail={props.email}
      />
      <UtmSourceAttributionModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitUtmSource}
      />
    </div>
  );
};

export default userEmailConnector(withRouter(ConfirmationPage));
